<template>
  <div></div>
</template>

<script>
import ComponentMixin from "../../ComponentMixin";

export default {
  mixins: [ComponentMixin],
  name: "RedirectPage",
  beforeMount() {
    const login_type = localStorage.getItem('nishika_login_type')
    localStorage.removeItem('nishika_login_type')
    if (login_type === 'email') {
      this.$auth.handleAuthentication()
    }
    const url = localStorage.getItem('nishika_redirect')
    const query = window.location.search
    localStorage.removeItem('nishika_redirect')
    if (url) {
      window.location.href = url
    } else if (query.indexOf('error=access_denied') > -1) {
      this.go('/clients')
    } else {
      this.go('/clients/jobs')
    }
  }
}
</script>

<style scoped>

</style>
